var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopLeftQuarterCircleOfGate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C7.41951e-07 23.5131 3.37142 15.3737 9.37258 9.37258C15.3737 3.37142 23.5131 -1.01206e-07 32 0V32L0 32Z",
    fill: "#FC9D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftQuarterCircleOfGate);
export default __webpack_public_path__ + "static/media/TopLeftQuarterCircleOfGate.e4f25f28.svg";
export { ForwardRef as ReactComponent };